import { connect } from 'react-redux'
import React, { Component, PropTypes } from 'react'
import ResetPasswordForm from 'client/features/session/components/ResetPasswordForm.jsx'
import { ResetPasswordRequest } from 'client/features/session/actions'
import FontAwesome from 'react-fontawesome'

class ResetPassword extends Component {

    submit(payload, dispatch) {
        dispatch(ResetPasswordRequest.post.action({ payload }))
    }

    render() {
        return (
            <div>
                <div className='text-center'>
                    <h4 className='text-uppercase font-bold m-b-0'>Demande nouveau mot de passe</h4>
                </div>
                <div className='panel-body'>
                    {
                        this.props.session.resetPasswordProgress ?
                            <FontAwesome name='cog' spin />
                        :
                            this.props.session.resetPasswordSubmited ?
                                <p>Un email de vérification vous a été envoyé.</p>
                            :
                                <ResetPasswordForm onSubmit={ this.submit }/>
                    }
                    {
                        this.props.session.resetPasswordFailure ?
                            <p className='error'>Email inconnu.</p>
                        : null 
                    }
                </div>
            </div>
        )
    }
}

ResetPassword.contextTypes = {
    router: PropTypes.object.isRequired,
    store: PropTypes.object.isRequired,
    session: PropTypes.object
}

const mapStateToProps = (state) => {
    const { session } = state
    return {
        session
    }
}

export default connect(mapStateToProps)(ResetPassword)


// WEBPACK FOOTER //
// ./src/client/features/session/containers/ResetPassword.jsx